import apollo from "@/apollo.js"
import gql from "graphql-tag"

export const createTeam = async (team) => {
  console.log(JSON.stringify(team, undefined, 2))
  const response = await apollo.mutate({
    mutation: gql(`
          mutation createTeam($displayName: String!, $commsEnabled: Boolean!, $metricsEnabled: Boolean!, $chatEnabled: Boolean!) {
            createTeam(displayName: $displayName, commsEnabled: $commsEnabled, metricsEnabled: $metricsEnabled, chatEnabled: $chatEnabled) {
              team { id displayName commsEnabled metricsEnabled chatEnabled } error message
            }
          }
        `),
    variables: team,
  })
  if (response && response.data && response.data.createTeam) {
    return response.data.createTeam
  } else {
    return undefined
  }
}

export const updateTeam = async (team) => {
  const response = await apollo.mutate({
    mutation: gql(`
          mutation updateTeam($id: Int!, $displayName: String!, $commsEnabled: Boolean!, $metricsEnabled: Boolean!, $chatEnabled: Boolean!) {
            updateTeam(id: $id, displayName: $displayName, commsEnabled: $commsEnabled, metricsEnabled: $metricsEnabled, chatEnabled: $chatEnabled) {
              error message
            }
          }
        `),
    variables: team,
  })
  if (response && response.data && response.data.updateTeam) {
    return response.data.updateTeam
  } else {
    return undefined
  }
}

export const deleteTeam = async (teamId) => {
  const response = await apollo.mutate({
    mutation: gql(`
          mutation deleteTeam($id: Int!) {
            deleteTeam(id: $id) {
              error message
            }
          }
        `),
    variables: { id: teamId },
  })
  if (response && response.data && response.data.deleteTeam) {
    return response.data.deleteTeam
  } else {
    return undefined
  }
}

export const createTeamMembership = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
            mutation createTeamMembership($teamId: Int!, $userId: Int!) {
              createTeamMembership(teamId: $teamId, userId: $userId) {
                error
                message
              }
            }
        `),
    variables: { teamId: data.teamId, userId: data.userId },
  })
  return response.data.createTeamMembership
}

export const deleteTeamMembership = async (data) => {
  const response = await apollo.mutate({
    mutation: gql(`
            mutation deleteTeamMembership($teamId: Int!, $userId: Int!) {
              deleteTeamMembership(teamId: $teamId, userId: $userId) {
                error
                message
              }
            }
        `),
    variables: { teamId: data.teamId, userId: data.userId },
  })
  return response.data.deleteTeamMembership
}
